<div class="status-message status-message--info" *ngIf="loading === true; else: button" class="loading-throbber"></div>
<ng-template #button>
  <div [ngClass]="'load-more-full'" *ngIf="
  areMoreData
  " (click)="loadMoreClick()">
    {{'load_more' | transloco}}
  </div>
</ng-template>
